'use strict';

// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable @typescript-eslint/naming-convention */
const AUTH_SUCCESSFULL_LOGIN_MESSAGE_NAME = 'AUTH_PAGE_SUCCESSFULL_LOGIN';
const AUTH_FAILURE_LOGIN_MESSAGE_NAME = 'AUTH_PAGE_FAILURE_LOGIN';
const AUTH_ROUTER_PREFIX_DEFAULT = '/openid/v2';
/**
 * @enum Типы ошибок
 */
exports.ACCESS_DENIED_REASON = void 0;
(function (ACCESS_DENIED_REASON) {
    /** Неизвестная ошибка */
    ACCESS_DENIED_REASON["UNKNOWN"] = "unknown";
    // ЕСИА
    /** Аккаунт ЕСИА уже привязан к другому пользователю */
    ACCESS_DENIED_REASON["ESIA_ACCOUNT_ALREADY_LINKED"] = "EsiaAccountAlreadyLinked";
    /** У пользователя уже есть привязанный аккаунт ЕСИА */
    ACCESS_DENIED_REASON["USER_ALREADY_HAS_ESIA_ACCOUNT"] = "UserAlreadyHasEsiaAccount";
    /** Во время авторизации в ЕСИА возникла не предвиденная проблема */
    ACCESS_DENIED_REASON["ESIA_AUTH_FAILED"] = "EsiaAuthFailed";
    /** Пользователь ЕСИА отказался предоставлять данные*/
    ACCESS_DENIED_REASON["ESIA_CONSENT_FAILED"] = "EsiaConsentFailed";
    /** Пользователь не подтвержден ЕСИА и не может запрашивать разрешения */
    ACCESS_DENIED_REASON["ESIA_USER_IS_NOT_VERIFIED"] = "EsiaUserIsNotVerified";
    /** Неполучилось скачать данные о пользователе ЕСИА (фио,снилс, и т.д.) */
    ACCESS_DENIED_REASON["FAILED_TO_FETCH_USER_INFO_FROM_ESIA"] = "FailedToFetchUserInfoFromEsia";
    /**
     * Неполучилось залогинится через ЕСИА,
     * ошибка может возникнуть на этапе логина пользователя в Identity(cохранение/обновление пользователя в бд и httpContext.Signin)
     */
    ACCESS_DENIED_REASON["FAILED_TO_LOGIN_VIA_ESIA"] = "FailedToLoginViaEsia";
    // ЕСИА
    // TBank
    /**
     * Неполучилось залогинится через TBANK,
     * ошибка может возникнуть на этапе логина пользователя в Identity(cохранение/обновление пользователя в бд и httpContext.Signin)
     */
    ACCESS_DENIED_REASON["FAILED_TO_LOGIN_VIA_TBANK"] = "FailedToLoginViaTBank";
    /** Во время авторизации в TBank возникла не предвиденная проблема */
    ACCESS_DENIED_REASON["TBANK_AUTH_FAILED"] = "TBankAuthFailed";
    /** Аккаунт TBank уже привязан к другому пользователю */
    ACCESS_DENIED_REASON["TBANK_ACCOUNT_ALREADY_LINKED"] = "TBankAccountAlreadyLinked";
    /** У пользователя уже есть привязанный аккаунт TBank */
    ACCESS_DENIED_REASON["USER_ALREADY_HAS_TBANK_ACCOUNT"] = "UserAlreadyHasTBankAccount";
    // TBank
    // Sber
    /**
     * Неполучилось залогинится через Sber,
     * ошибка может возникнуть на этапе логина пользователя в Identity(cохранение/обновление пользователя в бд и httpContext.Signin)
     */
    ACCESS_DENIED_REASON["FAILED_TO_LOGIN_VIA_SBER"] = "FailedToLoginViaSber";
    /** Во время авторизации в Sber возникла не предвиденная проблема */
    ACCESS_DENIED_REASON["SBER_AUTH_FAILED"] = "SberAuthFailed";
    /** Аккаунт Sber уже привязан к другому пользователю */
    ACCESS_DENIED_REASON["SBER_ACCOUNT_ALREADY_LINKED"] = "SberAccountAlreadyLinked";
    /** У пользователя уже есть привязанный аккаунт Sber */
    ACCESS_DENIED_REASON["USER_ALREADY_HAS_SBER_ACCOUNT"] = "UserAlreadyHasSberAccount";
    // Sber
    // Alfa
    /**
     * Неполучилось залогинится через ALFA,
     * ошибка может возникнуть на этапе логина пользователя в Identity(cохранение/обновление пользователя в бд и httpContext.Signin)
     */
    ACCESS_DENIED_REASON["FAILED_TO_LOGIN_VIA_ALFA"] = "FailedToLoginViaAlfa";
    /** Во время авторизации в TBank возникла не предвиденная проблема */
    ACCESS_DENIED_REASON["ALFA_AUTH_FAILED"] = "AlfaAuthFailed";
    /** Аккаунт TBank уже привязан к другому пользователю */
    ACCESS_DENIED_REASON["ALFA_ACCOUNT_ALREADY_LINKED"] = "AlfaAccountAlreadyLinked";
    /** У пользователя уже есть привязанный аккаунт TBank */
    ACCESS_DENIED_REASON["USER_ALREADY_HAS_ALFA_ACCOUNT"] = "UserAlreadyHasAlfaAccount";
    // Alfa
    /** Не хватает данных для показа пользователю соглашений */
    ACCESS_DENIED_REASON["NOT_ENOUGH_INFO_FOR_USER_AGREEMENTS"] = "NotEnoughInfoForUserAgreements";
    /** Не удалось сохранить данные необходимые для подписи согласий */
    ACCESS_DENIED_REASON["FAILED_TO_STORE_DATA_FOR_SIGN"] = "FailedToStoreDataForSign";
    /** Не удалось подписать пользовательские соглашения */
    ACCESS_DENIED_REASON["FAILED_TO_SIGN_USER_AGREEMENTS"] = "FailedToSignUserAgreements";
    /** Ошибки при запросе к сервису пользовательских соглашений */
    ACCESS_DENIED_REASON["FAILED_TO_REQUEST_USER_AGREEMENTS_SERVICE"] = "FailedToRequestUserAgreementsService";
    /** Не удалось получить данные для подписи пользовательских соглашений */
    ACCESS_DENIED_REASON["FAILED_TO_FETCH_DATA_FOR_USER_AGREEMENTS"] = "FailedToFetchDataForUserAgreements";
    /** Не удалось начать загрузку документов из ЕСИА (ПФР, НДФЛ, и. т.д.) */
    ACCESS_DENIED_REASON["FAILED_TO_START_LOADING_DOCUMENTS_FROM_ESIA"] = "FailedToStartLoadingDocumentsFromEsia";
    /** Не найден пользователь для привязки */
    ACCESS_DENIED_REASON["FAILED_TO_FIND_USER_FOR_LINKING"] = "FailedToFindUserForLinking";
})(exports.ACCESS_DENIED_REASON || (exports.ACCESS_DENIED_REASON = {}));
exports.ESIA_ENOUGH_INFO_FOR_USER_AGREEMENTS_KEYS = void 0;
(function (ESIA_ENOUGH_INFO_FOR_USER_AGREEMENTS_KEYS) {
    ESIA_ENOUGH_INFO_FOR_USER_AGREEMENTS_KEYS["PASSPORT_SERIES"] = "PassportSeries";
    ESIA_ENOUGH_INFO_FOR_USER_AGREEMENTS_KEYS["PASSPORT_NUMBER"] = "PassportNumber";
    ESIA_ENOUGH_INFO_FOR_USER_AGREEMENTS_KEYS["PASSPORT_ISSUED_BY"] = "PassportIssuedBy";
    ESIA_ENOUGH_INFO_FOR_USER_AGREEMENTS_KEYS["PASSPORT_ISSUER_ID"] = "PassportIssuerId";
    ESIA_ENOUGH_INFO_FOR_USER_AGREEMENTS_KEYS["PASSPORT_ISSUE_DATE"] = "PassportIssueDate";
    ESIA_ENOUGH_INFO_FOR_USER_AGREEMENTS_KEYS["SNILS"] = "Snils";
    ESIA_ENOUGH_INFO_FOR_USER_AGREEMENTS_KEYS["INN"] = "Inn";
    ESIA_ENOUGH_INFO_FOR_USER_AGREEMENTS_KEYS["BIRTHPLACE"] = "BirthPlace";
    ESIA_ENOUGH_INFO_FOR_USER_AGREEMENTS_KEYS["BIRTHDATE"] = "BirthDate";
})(exports.ESIA_ENOUGH_INFO_FOR_USER_AGREEMENTS_KEYS || (exports.ESIA_ENOUGH_INFO_FOR_USER_AGREEMENTS_KEYS = {}));
exports.AUTHENTICATION_UI_TYPE = void 0;
(function (AUTHENTICATION_UI_TYPE) {
    AUTHENTICATION_UI_TYPE["POPUP"] = "popup";
    AUTHENTICATION_UI_TYPE["PAGE"] = "page";
})(exports.AUTHENTICATION_UI_TYPE || (exports.AUTHENTICATION_UI_TYPE = {}));
exports.QUERY = void 0;
(function (QUERY) {
    QUERY["TYPE"] = "type";
    QUERY["REFERER"] = "referer";
    QUERY["RETURN_URL"] = "returnUrl";
    QUERY["REDIRECT"] = "redirect";
    QUERY["LOGIN_TYPE"] = "loginType";
    QUERY["LOGOUT_TYPE"] = "logoutType";
    QUERY["ACTION"] = "action";
    QUERY["PROMPT"] = "prompt";
    // Значение не совпадает специально, чтобы не было видно в гет параметрах что это связано с пользователем
    QUERY["USER_NAME"] = "hash";
    QUERY["TIMEOUT_EXPIRED"] = "timeoutExpired";
    QUERY["PIN_DISABLED"] = "pinDisabled";
    QUERY["PLACEMENT"] = "placement";
    QUERY["PRODUCT_ID"] = "productId";
    QUERY["ESIA_TYPE"] = "esiaType";
    QUERY["OTAC"] = "otac";
    QUERY["HINT"] = "hint";
    QUERY["CROSS_DOMAINS_ACTIONS_ENABLED"] = "crossDomains";
    // Костыль для альфа банка по разделению клиентов интеграции бека с банком
    QUERY["ALFA_CLIENT"] = "alfaClient";
    // @deprecated
    QUERY["OT"] = "ot";
    // @deprecated
    QUERY["ACR_VALUES"] = "acr_values";
})(exports.QUERY || (exports.QUERY = {}));
/** Типы авторизации */
exports.LOGIN_TYPE = void 0;
(function (LOGIN_TYPE) {
    LOGIN_TYPE["PHONE"] = "phone";
    LOGIN_TYPE["EMAIL"] = "email";
    LOGIN_TYPE["ESIA"] = "esia";
    LOGIN_TYPE["TBANK"] = "tbank";
    LOGIN_TYPE["ALFA"] = "alfa";
    LOGIN_TYPE["SBER"] = "sber";
    LOGIN_TYPE["OTAC"] = "otac";
})(exports.LOGIN_TYPE || (exports.LOGIN_TYPE = {}));
/** ПодТипы типа авторизации */
exports.ESIA_TYPE = void 0;
(function (ESIA_TYPE) {
    ESIA_TYPE["OPTIONAL"] = "optional";
    ESIA_TYPE["STRICT"] = "strict";
})(exports.ESIA_TYPE || (exports.ESIA_TYPE = {}));
/** Типы логаута */
exports.LOGOUT_TYPE = void 0;
(function (LOGOUT_TYPE) {
    LOGOUT_TYPE["SIMPLE"] = "simple";
})(exports.LOGOUT_TYPE || (exports.LOGOUT_TYPE = {}));
exports.ROUTES = void 0;
(function (ROUTES) {
    // Урлы для login
    ROUTES["LOGIN"] = "/login/";
    ROUTES["LOGIN_CONFIRM"] = "/login/confirm/";
    ROUTES["CALLBACK"] = "/callback/";
    ROUTES["SUCCESS"] = "/success/";
    // Урлы для logout
    ROUTES["LOGOUT"] = "/logout/";
    ROUTES["LOGOUT_CALLBACK"] = "/logout/callback/";
    ROUTES["SILENT_SIGNIN"] = "/silent/signin/";
    ROUTES["SILENT_SIGNIN_VERIFY"] = "/silent/signin/verify/";
    ROUTES["SILENT_SIGNIN_VERIFY_AND_CONSENTS"] = "/silent/signin/verify-code-and-consents/";
    ROUTES["SILENT_SIGNIN_CONSENTS"] = "/silent/signin/consents/";
    ROUTES["SILENT_CONNECT_TOKEN"] = "/silent/connect/token/";
    ROUTES["LOADING"] = "/loading/";
    // CrossDomains
    ROUTES["IFRAMES"] = "/crossdomains/iframes/";
    ROUTES["ACTION"] = "/crossdomains/action/";
})(exports.ROUTES || (exports.ROUTES = {}));
const AUTH_BROADCAST_CHANNEL_NAME = 'sravni_authentication_channel';

exports.AUTH_BROADCAST_CHANNEL_NAME = AUTH_BROADCAST_CHANNEL_NAME;
exports.AUTH_FAILURE_LOGIN_MESSAGE_NAME = AUTH_FAILURE_LOGIN_MESSAGE_NAME;
exports.AUTH_ROUTER_PREFIX_DEFAULT = AUTH_ROUTER_PREFIX_DEFAULT;
exports.AUTH_SUCCESSFULL_LOGIN_MESSAGE_NAME = AUTH_SUCCESSFULL_LOGIN_MESSAGE_NAME;
//# sourceMappingURL=consts.js.map
